import React from "react";
import { Col, Form, FormGroup, Input, Row } from "reactstrap";

import "../../assets/scss/components/login-register/index.scss";

import Config from "../../utils/config";
import Image from "../ImageComponent";

import InputText from "../InputText";
import Icon from "react-icons-kit";
import { ic_remove_red_eye } from "react-icons-kit/md/ic_remove_red_eye";
import { eyeBlocked } from "react-icons-kit/icomoon/eyeBlocked";
import { ic_lock } from "react-icons-kit/md/ic_lock";
import CustomBtn from "../CustomButton";

export default class SetNewPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newPassword: "",
      confirmPassword: "",
      ShowPassword: true,
    };
  }

  passwordAlert() {
    // toast.error('Password Didn\'t Match', {
    //   position: 'bottom-center',
    //   autoClose: 1200,
    //   hideProgressBar: true,
    //   closeOnClick: true,
    //   pauseOnHover: false,
    //   draggable: true,
    // });
  }

  handleChange = (e) => {
    e.preventDefault();
    let state = { ...this.state };
    state[e.target.name] = e.target.value;
    this.setState({ ...state });
  };
  handleToggleIcon = () => {
    let state = { ...this.state };
    state.ShowPassword = !state.ShowPassword;
    this.setState({ ...state });
  };

  handleSubmit = (e) => {
    const { newPassword, confirmPassword } = this.state;
    if (newPassword !== confirmPassword) {
      this.passwordAlert();
    } else {
      e.preventDefault();
      this.props.actions.setNewPassword(this.state);
    }
  };

  render() {
    let { confirmPassword } = this.state;
    return (
      <Row className=" no-gutters h-100">
        <Col
          sm="12"
          md="12"
          lg="12"
          xl="6"
          className="user-auth-wrapper h-100"
          style={{
            backgroundImage: `url(${Config.imageBaseUrl}/EU0001/node/assets/dashboard/riders-portal/login-banner.webp)`,
          }}
        ></Col>
        <Col sm="12" md="12" lg="12" xl="6" className="h-100 login-wrapper">
          <div className="light-overlay">
            <div className="user-auth-container">
              <div className="logo">
                <Image
                  tag="false"
                  src={`${Config.imageBaseUrl}/content/dam/re-platform-images/logo.svg`}
                  alt="Royal Enfield"
                />
              </div>

              <div className="app-login-register-container">
                <Form onSubmit={this.handleSubmit} className="w-100">
                  <div className="p-2 p-lg-0">
                    <div className="position-relative">
                      <Icon
                        size={22}
                        className="inputIcon LeftIcon"
                        icon={ic_lock}
                      />
                      <InputText
                        inputType={
                          this.state.ShowPassword ? "password" : "text"
                        }
                        inputName={"newPassword"}
                        InputClass={"mt-3 mt-lg-5 mb-4 inputText"}
                        inputPlaceholder={"New Password"}
                        customOnChange={(e) => this.handleChange(e)}
                        customIcon={ic_lock}
                        InputId={"newPassword"}
                        IconClass={"inputIcon LeftIcon"}
                        rightIcon={
                          this.state.ShowPassword
                            ? eyeBlocked
                            : ic_remove_red_eye
                        }
                        iconSize={22}
                      />
                      <Icon
                        size={18}
                        className="RightIcon inputIcon"
                        onClick={this.handleToggleIcon}
                        icon={
                          this.state.ShowPassword
                            ? eyeBlocked
                            : ic_remove_red_eye
                        }
                      />
                    </div>
                    {/* <FormGroup>

                        <Input
                          type='text'
                          name='newPassword'
                          id='newPassword'
                          placeholder='New Password'
                          className='inputText'
                          value={newPassword}
                          title="Please enter your new password"
                          required
                          onChange={(e) => this.handleChange(e)}
                        />
                      </FormGroup> */}
                    <div className="position-relative">
                      <Icon
                        size={22}
                        className="inputIcon LeftIcon"
                        icon={ic_lock}
                      />
                      <FormGroup>
                        <Input
                          type={this.state.ShowPassword ? "password" : "text"}
                          name="confirmPassword"
                          id="confirmPassword"
                          placeholder="Confirm Password"
                          className="inputText"
                          value={confirmPassword}
                          required
                          title="Please enter your new password again"
                          onChange={(e) => this.handleChange(e)}
                          validate={{ match: { value: "newPassword" } }}
                        />
                      </FormGroup>
                    </div>
                    <div className="bottom-sec">
                      <div className="d-flex align-items-center justify-content-center flex-column position-relative">
                        <CustomBtn
                          customType={"submit"}
                          name={"Set Password"}
                          customClass={
                            "btn-outline-dark mb-4 btnthemeColor"
                          }
                          // customClick={() => this.toggle()}
                          iconSize={30}
                        />
                        {/* <Link to="/auth/forget-password" className="link">
                          <span className="bg-white position-relative px-2">
                            {" "}
                            Forgot Password?
                          </span>
                        </Link> */}
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    );
  }
}
